import { type ComponentProps, forwardRef, useEffect } from 'react';

import { cn } from '@air/utils-tailwind';

import { SEARCH_STATIC_HEADER_Z_INDEX } from '~/constants/WorkspaceSpacing';
import { useSearchHeaderHeightContext } from '~/providers/SearchHeaderHeightProvider';

export type TopBarProps = Pick<ComponentProps<'div'>, 'children' | 'className' | 'style'>;

export const TopBar = forwardRef<HTMLDivElement, TopBarProps>(({ children, className, style }, forwardedRef) => {
  const { setSearchHeaderHeight } = useSearchHeaderHeightContext();

  useEffect(() => {
    if (forwardedRef && 'current' in forwardedRef && forwardedRef.current) {
      setSearchHeaderHeight(forwardedRef.current.offsetHeight);
    }
  }, [forwardedRef, setSearchHeaderHeight]);

  return (
    <div
      className={cn(
        'sticky inset-x-0 top-0 flex shrink-0 items-start justify-between gap-8 ads:bg-subtle bg-gray-3 px-3 py-1 font-medium ads:text-secondary text-12 text-gray-11 ads:md:bg-base md:bg-gray-1 md:px-12 md:py-4',
        'min-h-[56px] items-center px-4 md:items-start',
        className,
      )}
      style={{
        zIndex: SEARCH_STATIC_HEADER_Z_INDEX,
        ...style,
      }}
      ref={forwardedRef}
    >
      {children}
    </div>
  );
});

TopBar.displayName = 'TopBar';
